const UPLOAD_SPREADSHEET_STEP = 'uploadSpreadSheet';
const REVIEW_IMPORT_STEP = 'reviewImport';

const STEP = {
  select: 'select',
  form: 'form',
  spreadSheet: 'spreadSheet'
};

export { REVIEW_IMPORT_STEP, STEP, UPLOAD_SPREADSHEET_STEP };
